import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ChevronDown, User, Settings, LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuthStore, selectIsAdmin } from '../../store/useAuthStore';
import { useSignOut } from '../auth/AuthProvider';
import { Avatar } from '../ui/Avatar';
import { cn } from '../../lib/cn';

export function UserMenu() {
  const collaborator = useAuthStore((s) => s.collaborator);
  const isAdmin = useAuthStore(selectIsAdmin);
  const signOut = useSignOut();

  if (!collaborator) return null;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className={cn(
            'flex items-center gap-1.5 px-1.5 py-1 rounded-[10px]',
            'hover:bg-neutral-100 transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cime-primary',
          )}
          aria-label="Menu utilisateur"
        >
          <Avatar
            name={collaborator.full_name}
            src={collaborator.avatar_url}
            size="sm"
            className="w-8 h-8 text-[11px]"
          />
          <ChevronDown className="w-3.5 h-3.5 text-neutral-400" aria-hidden />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className={cn(
            'z-50 min-w-[200px] bg-white rounded-cime border border-neutral-200 shadow-lg p-1',
            'animate-in fade-in-0 zoom-in-95',
          )}
        >
          {/* User info header */}
          <div className="px-3 py-2 mb-1">
            <p className="text-sm font-medium text-neutral-900 truncate">
              {collaborator.full_name}
            </p>
            <p className="text-xs text-neutral-500 truncate">{collaborator.email}</p>
          </div>

          <DropdownMenu.Separator className="h-px bg-neutral-200 mx-1 mb-1" />

          <DropdownMenu.Item asChild>
            <Link
              to="/profil"
              className={cn(
                'flex items-center gap-2 px-3 py-2 text-sm rounded-md',
                'text-neutral-700 hover:bg-neutral-100 cursor-pointer outline-none',
                'data-[highlighted]:bg-neutral-100',
              )}
            >
              <User className="w-4 h-4" aria-hidden />
              Mon profil
            </Link>
          </DropdownMenu.Item>

          {/* Paramètres — admin only */}
          {isAdmin ? (
            <DropdownMenu.Item asChild>
              <Link
                to="/parametres"
                className={cn(
                  'flex items-center gap-2 px-3 py-2 text-sm rounded-md',
                  'text-neutral-700 hover:bg-neutral-100 cursor-pointer outline-none',
                  'data-[highlighted]:bg-neutral-100',
                )}
              >
                <Settings className="w-4 h-4" aria-hidden />
                Paramètres
              </Link>
            </DropdownMenu.Item>
          ) : null}

          <DropdownMenu.Separator className="h-px bg-neutral-200 mx-1 my-1" />

          {/* Déconnexion */}
          <DropdownMenu.Item
            onSelect={() => void signOut()}
            className={cn(
              'flex items-center gap-2 px-3 py-2 text-sm rounded-md',
              'text-red-600 hover:bg-red-50 cursor-pointer outline-none',
              'data-[highlighted]:bg-red-50',
            )}
          >
            <LogOut className="w-4 h-4" aria-hidden />
            Se déconnecter
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
